import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Search } from "lucide-react";
import sellCarImage from "../../assets/sell-car1.png";
import indIcon from "../../assets/Ind.png";
import styles from "./SellYourCarDetails.module.css";

const carData = {
  makes: [
    "Maruti Suzuki", "Hyundai", "Tata", "Mahindra", "Honda", "Toyota", "Kia", "MG", "Renault", "Ford"
  ],
  models: {
    "Maruti Suzuki": [
      "Swift", "Baleno", "Dzire", "Brezza", "Alto", "Wagon R", "Ertiga", "Celerio",
      "Ciaz", "Eeco", "Fronx", "Jimny", "Invicto"
    ],
    "Hyundai": [
      "i10", "i20", "Creta", "Venue", "Verna", "Aura", "Alcazar", "Tucson",
      "Kona", "Grand i10", "Exter", "Ioniq 5"
    ],
    "Tata": [
      "Nexon", "Harrier", "Safari", "Punch", "Tiago", "Tigor", "Altroz",
      "Curvv", "Sierra", "Avinya"
    ],
    "Mahindra": [
      "XUV700", "Scorpio", "Thar", "XUV300", "Bolero", "Marazzo", "KUV100",
      "XUV400", "TUV300", "Alturas"
    ],
    "Honda": [
      "City", "Amaze", "WR-V", "Jazz", "Civic", "Accord", "CR-V",
      "HR-V", "BR-V", "Brio"
    ],
    "Toyota": [
      "Innova Crysta", "Fortuner", "Urban Cruiser", "Glanza", "Camry", "Corolla Altis",
      "Hilux", "Vellfire", "Rumion"
    ],
    "Kia": [
      "Seltos", "Sonet", "Carens", "Carnival", "Sportage", "EV6"
    ],
    "MG": [
      "Hector", "Hector Plus", "ZS EV", "Gloster", "Astor", "Comet EV"
    ],
    "Renault": [
      "Kwid", "Triber", "Kiger", "Duster", "Captur", "Koleos"
    ],
    "Ford": [
      "EcoSport", "Aspire", "Figo", "Freestyle", "Endeavour"
    ]
  },
  years: {
    Swift: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Baleno: ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Dzire: ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Brezza: ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Alto: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "Wagon R": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Ertiga: ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Celerio: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Ciaz: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    Eeco: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Fronx: ["2023", "2024"],
    Jimny: ["2023", "2024"],
    Invicto: ["2023", "2024"],

    i10: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    i20: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Creta: ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Venue: ["2019", "2020", "2021", "2022", "2023", "2024"],
    Verna: ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Aura: ["2020", "2021", "2022", "2023", "2024"],
    Alcazar: ["2021", "2022", "2023", "2024"],
    Tucson: ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Kona: ["2019", "2020", "2021", "2022", "2023"],
    "Grand i10": ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Exter: ["2023", "2024"],
    "Ioniq 5": ["2023", "2024"],

    Nexon: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Harrier: ["2019", "2020", "2021", "2022", "2023", "2024"],
    Safari: ["2021", "2022", "2023", "2024"],
    Punch: ["2021", "2022", "2023", "2024"],
    Tiago: ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Tigor: ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Altroz: ["2020", "2021", "2022", "2023"],
    Curvv: ["2024"],
    Sierra: ["2024"],
    Avinya: ["2025"],

    XUV700: ["2021", "2022", "2023", "2024"],
    Scorpio: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Thar: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    XUV300: ["2019", "2020", "2021", "2022", "2023", "2024"],
    Bolero: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    Marazzo: ["2018", "2019", "2020", "2021", "2022", "2023"],
    KUV100: ["2016", "2017", "2018", "2019", "2020"],
    XUV400: ["2023", "2024"],
    TUV300: ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    Alturas: ["2018", "2019", "2020", "2021", "2022"],

    City: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    Amaze: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
    "WR-V": ["2017", "2018", "2019", "2020", "2021", "2022"],
    Jazz: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    Civic: ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    Accord: ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "CR-V": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "HR-V": ["2023"],
    "BR-V": ["2016", "2017", "2018", "2019", "2020", "2021"],
    Brio: ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],

    "Innova Crysta": ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Fortuner: ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    "Urban Cruiser": ["2020", "2021", "2022"],
    Glanza: ["2019", "2020", "2021", "2022", "2023"],
    Camry: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "Corolla Altis": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    Hilux: ["2022", "2023", "2024"],
    Vellfire: ["2020", "2021", "2022", "2023", "2024"],
    Rumion: ["2023", "2024"],

    Seltos: ["2019", "2020", "2021", "2022", "2023"],
    Sonet: ["2020", "2021", "2022", "2023"],
    Carens: ["2022", "2023", "2024"],
    Carnival: ["2020", "2021", "2022", "2023"],
    Sportage: ["2022", "2023", "2024"],
    EV6: ["2022", "2023", "2024"],

    Hector: ["2019", "2020", "2021", "2022", "2023"],
    "Hector Plus": ["2020", "2021", "2022", "2023"],
    "ZS EV": ["2020", "2021", "2022", "2023"],
    Gloster: ["2020", "2021", "2022", "2023"],
    Astor: ["2021", "2022", "2023"],
    "Comet EV": ["2023", "2024"],

    Kwid: ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
    Triber: ["2019", "2020", "2021", "2022", "2023", "2024"],
    Kiger: ["2021", "2022", "2023", "2024"],
    Duster: ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    Captur: ["2017", "2018", "2019", "2020"],
    Koleos: ["2011", "2012", "2013", "2014"],

    EcoSport: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    Aspire: ["2015", "2016", "2017", "2018", "2019", "2020"],
    Figo: ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
    Freestyle: ["2018", "2019", "2020", "2021"],
    Endeavour: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"]
  },
  variants: {
    // --- Maruti Suzuki (Already present) ---
    Swift: ["LXI", "VXI", "ZXI", "ZXI+", "VXI AMT", "ZXI AMT", "ZXI+ AMT"],
    Baleno: ["Sigma", "Delta", "Zeta", "Alpha", "Delta AT", "Zeta AT", "Alpha AT"],
    Dzire: ["LXI", "VXI", "ZXI", "ZXI+", "VXI AMT", "ZXI AMT", "ZXI+ AMT"],
    Brezza: ["LXI", "VXI", "ZXI", "ZXI+", "VXI+", "ZXI Dual Tone", "ZXI+ Dual Tone"],
    Alto: ["LXI", "VXI", "VXI+", "LX CNG", "VXI CNG"],
    "Wagon R": ["LXI", "VXI", "VXI+", "ZXI", "ZXI+", "LXI CNG", "VXI CNG"],
    Ertiga: ["LXI", "VXI", "ZXI", "ZXI+", "ZXI+ AT", "CNG VXI", "CNG ZXI"],
    Celerio: ["LXI", "VXI", "ZXI", "ZXI+", "LXI CNG", "VXI CNG", "ZXI CNG"],
    Ciaz: ["Sigma", "Delta", "Zeta", "Alpha", "Alpha AT", "Zeta AT", "Alpha Dual Tone"],
    Eeco: ["STD", "STD AC", "DELUXE", "DELUXE AC", "CNG STD", "CNG DELUXE"],
    Fronx: ["Sigma", "Delta", "Delta+ Turbo", "Zeta", "Alpha"],
    Jimny: ["Zeta", "Alpha"],
    Invicto: ["Zeta+ 7STR", "Zeta+ 8STR"],

    // --- Hyundai ---
    i10: ["Era", "Magna", "Sportz", "Asta", "Sportz (O)", "Asta (O)"],
    i20: ["Era", "Magna", "Sportz", "Asta", "Asta (O)", "Sportz DCT", "Asta DCT"],
    Creta: ["E", "EX", "S", "SX", "SX(O)", "SX Executive", "S Plus", "SX(O) DCT", "SX Tech"],
    Venue: ["E", "S", "S(O)", "SX", "SX(O)", "SX(O) DCT", "SX+", "Denim", "Knight"],
    Verna: ["S", "SX", "SX(O)", "SX Plus", "SX Plus(O)", "SX Turbo", "EX"],
    Aura: ["E", "S", "SX", "SX+ Turbo", "SX+ AMT", "CNG SX", "SX (O)"],
    Alcazar: ["Prestige", "Platinum", "Signature", "Prestige (O)", "Platinum (O)", "Signature (O)"],
    Tucson: ["GL (O)", "GLS 2WD", "GLS 4WD", "Platinum", "Platinum AT"],
    Kona: ["Premium", "Premium Dual Tone"],
    "Grand i10": ["Era", "Magna", "Sportz", "Asta", "Sportz (O)", "Asta (O)"],
    Exter: ["EX", "S", "SX", "SX (O)", "SX (O) Connect"], // sample
    "Ioniq 5": ["Single Variant"],

    // --- Tata ---
    Nexon: ["XE", "XM", "XZ", "XZ+", "XZ+ Lux", "XMA", "XZA+", "XZA+ DT", "Dark", "Kaziranga Edition", "Jet Edition"],
    Harrier: ["XE", "XM", "XT", "XT+", "XZ", "XZ+", "XZ+ Dual Tone", "Dark Edition", "Camo Edition"],
    Safari: ["XE", "XM", "XT", "XT+", "XZ", "XZ+", "Adventure Persona", "Gold", "Dark", "Kaziranga"],
    Punch: ["Pure", "Adventure", "Accomplished", "Creative", "Kaziranga Edition", "Camo", "Dark"],
    Tiago: ["XE", "XT", "XZ", "XZ+", "XTA", "XZA", "XZA+", "Tiago NRG"],
    Tigor: ["XE", "XM", "XZ", "XZ+", "XMA", "XZA", "XZA+", "XZ+ Dual Tone", "EV XM", "EV XZ+"],
    Altroz: ["XE", "XM", "XT", "XZ", "XZ+", "Dark", "Turbo", "IxS", "iTurbo"],
    Curvv: ["XE", "XM", "XT", "XZ", "XZ+"],   // sample
    Sierra: ["Comfort Plus", "Adventure Edition"], // concept, sample
    Avinya: ["Core", "Smart", "Signature"],   // concept, sample

    // --- Mahindra ---
    XUV700: ["MX", "AX3", "AX5", "AX7", "AX7L", "AX7 Diesel", "Luxury Pack"],
    Scorpio: ["S2", "S3", "S5", "S7", "S9", "S11", "Classic S", "Classic S11", "N", "Z"],
    Thar: ["AX", "LX", "AX (O)", "LX Hard Top", "LX Convertible", "RWD Diesel", "RWD Petrol"],
    XUV300: ["W4", "W6", "W8", "W8(O)", "TurboSport", "AMT"],
    Bolero: ["B2", "B4", "B6", "B6(O)"],
    Marazzo: ["M2", "M4", "M6", "M8"],
    KUV100: ["K2", "K4", "K6", "K8"],
    XUV400: ["EC", "EL"],
    TUV300: ["T4", "T6", "T8"],
    Alturas: ["G4 2WD", "G4 4WD"],

    // --- Honda ---
    City: ["SV", "V", "VX", "ZX", "ZX CVT", "Hybrid ZX"],
    Amaze: ["E", "S", "V", "VX", "S CVT", "VX CVT"],
    "WR-V": ["SV", "VX", "VX Exclusive", "Edge Edition"],
    Jazz: ["V", "VX", "ZX", "Select Edition"],
    Civic: ["V", "VX", "ZX", "Diesel VX", "Petrol V"],
    Accord: ["Hybrid", "V6", "2.4 Elegance"],
    "CR-V": ["2WD", "4WD", "2L", "Petrol Automatic"],
    "HR-V": ["S", "V", "VX"], // concept/sample
    "BR-V": ["E", "S", "V", "VX"],
    Brio: ["EMT", "SMT", "VMT", "VX"],

    // --- Toyota ---
    "Innova Crysta": ["GX", "VX", "ZX", "GX AT", "VX AT", "ZX AT", "Touring Sport", "Limited Edition"],
    Fortuner: ["2.7 4x2 MT", "2.7 4x2 AT", "2.8 4x4 MT", "2.8 4x4 AT", "Legender", "GR-S"],
    "Urban Cruiser": ["Mid", "High", "Premium"],
    Glanza: ["E", "S", "V", "G", "G CVT", "V CVT"],
    Camry: ["Hybrid", "Hybrid 2.5"],
    "Corolla Altis": ["J", "G", "GL", "VL", "D-4D", "H2", "H5"],
    Hilux: ["Standard", "High MT", "High AT"],
    Vellfire: ["Executive Lounge"],
    Rumion: ["S", "G", "V"],

    // --- Kia ---
    Seltos: ["HTE", "HTK", "HTK+", "HTX", "HTX+", "GTX+", "X Line", "GT Line"],
    Sonet: ["HTE", "HTK", "HTK+", "HTX", "HTX+", "GTX+", "X Line"],
    Carens: ["Premium", "Prestige", "Luxury", "Luxury Plus", "X Line"],
    Carnival: ["Premium", "Prestige", "Limousine", "Limousine Plus"],
    Sportage: ["LX", "EX", "GT"],
    EV6: ["GT Line", "GT Line AWD"],

    // --- MG ---
    Hector: ["Style", "Super", "Smart", "Sharp", "Savvy"],
    "Hector Plus": ["Smart 6STR", "Sharp 6STR", "Smart 7STR", "Sharp 7STR"],
    "ZS EV": ["Excite", "Exclusive"],
    Gloster: ["Super", "Smart", "Sharp", "Savvy", "Savvy 4x4"],
    Astor: ["Style", "Super", "Smart", "Sharp", "Savvy"],
    "Comet EV": ["Pace", "Play", "Plush"],

    // --- Renault ---
    Kwid: ["STD", "RXE", "RXL", "RXT", "Climber"],
    Triber: ["RXE", "RXL", "RXT", "RXZ"],
    Kiger: ["RXE", "RXL", "RXT", "RXZ", "Turbo RXT", "Turbo RXZ"],
    Duster: ["RXE", "RXS", "RXS Turbo", "RXZ", "RXZ Turbo", "Adventure Edition"],
    Captur: ["RXE", "RXL", "RXT", "Platinium", "Platine"],
    Koleos: ["E4 4x4", "E6"],

    // --- Ford ---
    EcoSport: ["Ambiente", "Trend", "Titanium", "Titanium+", "Sports", "Thunder Edition", "S"],
    Aspire: ["Ambiente", "Trend", "Trend+", "Titanium", "Titanium+", "Blu"],
    Figo: ["Ambiente", "Trend", "Titanium", "Titanium Blu", "Sports"],
    Freestyle: ["Ambiente", "Trend", "Titanium", "Titanium+", "Flair"],
    Endeavour: ["Trend", "Titanium", "Titanium+", "Sport", "Endeavour 3.2 Titanium AT 4X4"]
  },
  kmDriven: [
    "Under 10,000", "10,000-30,000", "30,000-50,000", "50,000-70,000", "70,000-100,000", "Above 100,000"
  ],
  whenToSell: [
    "Immediately", "Within a week", "Within a month", "After 3 months", "After 6 months"
  ]
};

function SellYourCarDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [vehicleNumber, setVehicleNumber] = useState(state?.vehicleNumber || "");
  const [contactDetails, setContactDetails] = useState({
    name: "",
    email: "",
    phone: ""
  });
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const [contactError, setContactError] = useState("");
  const [documentError, setDocumentError] = useState("");
  const [activeTab, setActiveTab] = useState("make");
  const [selectedOptions, setSelectedOptions] = useState({
    make: "",
    model: "",
    year: "",
    variant: "",
    kmDriven: "",
    whenToSell: ""
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [apiError, setApiError] = useState(null);

  const validateVehicleNumber = (number) => {
    const cleanedNumber = number.replace(/\s/g, "").toUpperCase();
    const regex = /^[A-Z]{2}[0-9]{1,2}[A-Z]{0,3}[0-9]{1,4}$/;
    const validStateCodes = [
      "AN", "AP", "AR", "AS", "BR", "CH", "CG", "DD", "DL", "GA", "GJ", "HR", "HP",
      "JH", "JK", "KA", "KL", "LD", "MP", "MH", "MN", "ML", "MZ", "NL", "OD", "PY",
      "PB", "RJ", "SK", "TN", "TS", "TR", "UP", "UK", "WB"
    ];

    if (!cleanedNumber) {
      return "Please enter a vaahan number";
    }
    if (!regex.test(cleanedNumber)) {
      return "Invalid vaahan number format. Please enter a valid Indian vaahan number (e.g., DL3SDW2595, UP57BX1666).";
    }
    const stateCode = cleanedNumber.substring(0, 2);
    if (!validStateCodes.includes(stateCode)) {
      return "Invalid state code. Please use a valid Indian state code (e.g., DL, MH, UP).";
    }
    return "";
  };

  const validateContactDetails = () => {
    const { name, email, phone } = contactDetails;
    if (!name.trim()) return "Please enter your name";
    if (!email.trim()) return "Please enter your email address";
    if (!phone.trim()) return "Please enter your phone number";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "Please enter a valid email address";
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(phone)) return "Please enter a valid 10-digit phone number starting with 6-9";
    return "";
  };

  const validateDocuments = () => files.length === 0 ? "Please upload your Aadhar card." : "";

  const handleSearch = () => setError(validateVehicleNumber(vehicleNumber));
  const handleContactChange = e => setContactDetails(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const handleFileChange = e => setFiles(prev => [...prev, ...Array.from(e.target.files)]);

  const handleGetQuote = async () => {
    const token = localStorage.getItem("token");
    const vehicle_id = localStorage.getItem("vehicle_id");
    const contactValidationError = validateContactDetails();
    if (contactValidationError) { setContactError(contactValidationError); return; }
    const documentValidationError = validateDocuments();
    if (documentValidationError) { setDocumentError(documentValidationError); return; }
    if (!token) { setApiError("Authentication token missing. Please log in again."); return; }
    if (!vehicle_id) { setApiError("Vaahan ID missing. Please select a vaahan."); return; }
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);
    const form = new FormData();
    form.append("service_type", "sellYourCar");
    form.append("vehicle_id", vehicle_id);
    form.append(
      "additional_info",
      JSON.stringify({
        vehicle_number: vehicleNumber,
        make: selectedOptions.make,
        model: selectedOptions.model,
        year: selectedOptions.year,
        variant: selectedOptions.variant,
        km_driven: selectedOptions.kmDriven,
        when_to_sell: selectedOptions.whenToSell,
        contact_details: contactDetails
      })
    );
    files.forEach(file => form.append("documents", file));
    try {
      const response = await fetch(
        "https://api.rtoxpert.com/api/service-requests",
        { method: "POST", headers, body: form, redirect: "follow" }
      );
      if (response.ok) {
        setShowPopup(true);
        setApiError(null);
        setContactError("");
        setDocumentError("");
        setTimeout(() => { setShowPopup(false); navigate("/profile"); }, 2000);
      } else {
        const errorText = await response.text();
        setApiError("Submission failed: " + errorText);
      }
    } catch (err) {
      setApiError("Error occurred: " + err.message);
    }
  };

  // ------- Per-model display logic -------
  const getDisplayData = () => {
    switch (activeTab) {
      case "make":
        return carData.makes;
      case "model":
        return selectedOptions.make ? carData.models[selectedOptions.make] || [] : [];
      case "year":
        return selectedOptions.model ? (carData.years[selectedOptions.model] || []) : [];
      case "variant":
        return selectedOptions.model ? carData.variants[selectedOptions.model] || [] : [];
      case "kmDriven":
        return carData.kmDriven;
      case "whenToSell":
        return carData.whenToSell;
      default:
        return [];
    }
  };

  const handleTabChange = (tab) => {
    if ((tab === "model" && !selectedOptions.make) ||
      (tab === "variant" && !selectedOptions.model) ||
      (tab === "year" && !selectedOptions.model)
    ) { return; }
    setActiveTab(tab);
    setSearchQuery("");
  };

  const handleOptionSelect = (option) => {
    const newSelectedOptions = { ...selectedOptions, [activeTab]: option };
    if (activeTab === "make") {
      newSelectedOptions.model = "";
      newSelectedOptions.year = "";
      newSelectedOptions.variant = "";
    }
    if (activeTab === "model") {
      newSelectedOptions.year = "";
      newSelectedOptions.variant = "";
    }
    if (activeTab === "year") {
      newSelectedOptions.variant = "";
    }
    setSelectedOptions(newSelectedOptions);
    const tabOrder = ["make", "model", "year", "variant", "kmDriven", "whenToSell"];
    const currentIndex = tabOrder.indexOf(activeTab);
    if (currentIndex < tabOrder.length - 1) {
      setActiveTab(tabOrder[currentIndex + 1]);
    }
  };

  const filteredOptions = getDisplayData().filter(option =>
    option.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const getTabTitle = () => {
    switch (activeTab) {
      case "make": return "Make";
      case "model": return "Model";
      case "year": return "Year";
      case "variant": return "Variant";
      case "kmDriven": return "KM Driven";
      case "whenToSell": return "When To Sell";
      default: return "";
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <div className={styles.headerGroup}>
            <h1 className={styles.title}>
              Get The <span className={styles.highlight}>Best Price</span> For
              Your Car
            </h1>
            <p className={styles.subtitle}>
              Instant Quote. Multiple Partners. Same Day Processing
            </p>
          </div>
          <div className={styles.searchBox}>
            <div className={styles.searchContainer}>
              <div className={styles.indSection}>
                <div className={styles.prefix}>
                  <img src={indIcon} alt="IND" />
                </div>
              </div>
              <input
                type="text"
                placeholder="MH 15 CV 2211"
                className={styles.searchInput}
                value={vehicleNumber}
                onChange={(e) => setVehicleNumber(e.target.value.toUpperCase())}
              />
              <button className={styles.searchButton} onClick={handleSearch}>
                <Search size={20} />
              </button>
            </div>
            {error && <p className={styles.error}>{error}</p>}
          </div>
          <div className={styles.contactDetails}>
            <h3 className={styles.sectionTitle}>Contact Details</h3>
            <div className={styles.contactInputs}>
              <div className={styles.inputGroup}>
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Full Name"
                  className={styles.searchInput}
                  value={contactDetails.name}
                  onChange={handleContactChange}
                />
              </div>
              <div className={styles.inputGroup}>
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email Address"
                  className={styles.searchInput}
                  value={contactDetails.email}
                  onChange={handleContactChange}
                />
              </div>
              <div className={styles.inputGroup}>
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Phone Number"
                  className={styles.searchInput}
                  value={contactDetails.phone}
                  onChange={handleContactChange}
                />
              </div>
            </div>
            {contactError && <p className={styles.error}>{contactError}</p>}
          </div>
          <div className={styles.documentUpload}>
            <h3 className={styles.sectionTitle}>Upload Aadhar Card</h3>
            <div className={styles.fileInputGroup}>
              <label className={styles.fileUploadLabel}>
                Choose File
                <input
                  type="file"
                  className={styles.fileInput}
                  onChange={handleFileChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </label>
              {files.length > 0 && (
                <ul className={styles.uploadedFiles}>
                  {files.map((file, index) => (
                    <li key={index} className={styles.fileItem}>
                      📄 {file.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {documentError && <p className={styles.error}>{documentError}</p>}
          </div>
        </div>
        <div className={styles.rightContent}>
          <div className={styles.imageWrapper}>
            <div className={styles.blueCircle}></div>
            <img
              src={sellCarImage}
              alt="Traffic officer checking vaahan with driver using smartphone app"
              className={styles.image}
            />
          </div>
        </div>
      </div>

      <div className={styles.selectionContainer}>
        {apiError && <div className={styles.errorMessage}>{apiError}</div>}
        <div className={styles.selectionSummary}>
          {vehicleNumber && (
            <div className={styles.selectionChip}>{vehicleNumber}</div>
          )}
          {selectedOptions.make && (
            <div className={styles.selectionChip}>{selectedOptions.make}</div>
          )}
          {selectedOptions.model && (
            <div className={styles.selectionChip}>{selectedOptions.model}</div>
          )}
          {selectedOptions.year && (
            <div className={styles.selectionChip}>{selectedOptions.year}</div>
          )}
          {selectedOptions.variant && (
            <div className={styles.selectionChip}>{selectedOptions.variant}</div>
          )}
          {selectedOptions.kmDriven && (
            <div className={styles.selectionChip}>{selectedOptions.kmDriven}</div>
          )}
          {selectedOptions.whenToSell && (
            <div className={styles.selectionChip}>{selectedOptions.whenToSell}</div>
          )}
        </div>
        <div className={styles.filterTabs}>
          <button
            className={`${styles.filterTab} ${activeTab === "make" ? styles.activeTab : ""}`}
            onClick={() => handleTabChange("make")}
          >
            Select Car
          </button>
          <button
            className={`${styles.filterTab} ${activeTab === "model" ? styles.activeTab : ""}`}
            onClick={() => handleTabChange("model")}
          >
            Model
          </button>
          <button
            className={`${styles.filterTab} ${activeTab === "year" ? styles.activeTab : ""}`}
            onClick={() => handleTabChange("year")}
          >
            Year
          </button>
          <button
            className={`${styles.filterTab} ${activeTab === "variant" ? styles.activeTab : ""}`}
            onClick={() => handleTabChange("variant")}
          >
            Variant
          </button>
          <button
            className={`${styles.filterTab} ${activeTab === "kmDriven" ? styles.activeTab : ""}`}
            onClick={() => handleTabChange("kmDriven")}
          >
            KM Driven
          </button>
          <button
            className={`${styles.filterTab} ${activeTab === "whenToSell" ? styles.activeTab : ""}`}
            onClick={() => handleTabChange("whenToSell")}
          >
            When To Sell
          </button>
        </div>
        <div className={styles.makeSearchContainer}>
          <input
            type="text"
            placeholder={`Search for ${activeTab}`}
            className={styles.makeSearchInput}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button className={styles.makeSearchButton}>
            <Search size={20} />
          </button>
        </div>
        <h3 className={styles.sectionTitle}>{getTabTitle()}</h3>
        <div className={styles.makeGrid}>
          {filteredOptions.map((option, index) => (
            <button
              key={index}
              className={`${styles.makeButton} ${selectedOptions[activeTab] === option ? styles.activeMake : ""}`}
              onClick={() => handleOptionSelect(option)}
            >
              {option}
            </button>
          ))}
          {filteredOptions.length === 0 && (
            <div className={styles.noResults}>No options available. Please make a selection in the previous step.</div>
          )}
        </div>
        {selectedOptions.make && selectedOptions.model && selectedOptions.year &&
          selectedOptions.variant && selectedOptions.kmDriven && selectedOptions.whenToSell && (
            <button className={styles.continueButton} onClick={handleGetQuote}>
              Get Quote
            </button>
          )}
        {showPopup && (
          <div className={styles.successMessage}>
            Agent will reach out to you soon.
          </div>
        )}
      </div>
    </div>
  );
}

export default SellYourCarDetails;
